function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.586 4.726L.961.113a.388.388 0 00-.547.549L4.764 5 .414 9.338a.388.388 0 10.547.549l4.625-4.613a.387.387 0 000-.548z",
  fill: "#0785FE"
});

function SvgArrowLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    fill: "none"
  }, props), _ref);
}

export default SvgArrowLink;